import styles from './ProgressDots.module.css';

interface ProgressDotsProps {
  /** 현재 채워진 점 개수 (0..total). */
  filled: number;
  /** 전체 점 개수. 어린이날 릴레이는 항상 3. */
  total: number;
}

/**
 * 진행 표시 — 단순 카운터.
 *
 * 코드 입력 진행 상황을 "n / 3" 형태의 텍스트로 한 줄로 보여준다.
 * 시각적 노이즈 없이 깔끔한 카운터 스타일.
 */
export function ProgressDots({ filled, total }: ProgressDotsProps): React.JSX.Element {
  return (
    <div
      className={styles.row}
      role="progressbar"
      aria-valuenow={filled}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={`${String(filled)} / ${String(total)} 진행`}
    >
      <span className={styles.value}>{filled}</span>
      <span className={styles.divider}>/</span>
      <span className={styles.total}>{total}</span>
    </div>
  );
}
